import { Link } from 'react-router-dom';

const URL_RE = /(https?:\/\/[^\s)]+[^\s).,!?])/g;
const INTERNAL = /^https?:\/\/(www\.)?(dyssc\.com|[^/]*emergent[^/]*)(\/[^\s]*)?$/i;

export const ChatLinkText = ({ text, className = '' }) => (
  <span>
    {text.split(URL_RE).map((part, i) => {
      if (i % 2 === 0) return part;
      const m = part.match(INTERNAL);
      const cls = `underline underline-offset-2 break-all ${className}`;
      return m ? (
        <Link key={i} to={m[3] || '/'} className={cls} data-testid="chat-link">{(m[3] || '/').replace(/^\//, 'dyssc.com/')}</Link>
      ) : (
        <a key={i} href={part} target="_blank" rel="noopener noreferrer" className={cls} data-testid="chat-link">{part}</a>
      );
    })}
  </span>
);
